import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material'

type DetailInputProps<T> = {
  label: string
  field: keyof T
  type?: 'text' | 'number' | 'email' | 'url'
  required?: boolean
  placeholder?: string
  helperText?: string
  tempDetail: Partial<T>
  setTempDetail?: React.Dispatch<React.SetStateAction<Partial<T>>>
  keyDownSubmit: (e: React.KeyboardEvent) => void
  displayTransformer?: (value: unknown) => string | number
  startAdornment?: React.ReactNode
  onChange?: (value: any) => void
}
function DetailInput<T>(props: DetailInputProps<T>) {
  const {
    label,
    field,
    required = false,
    helperText,
    placeholder,
    type = 'text',
    tempDetail,
    setTempDetail,
    keyDownSubmit,
    startAdornment,
    displayTransformer,
  } = props

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        id={`detail-input-${String(field)}`}
        label={label}
        value={
          displayTransformer
            ? displayTransformer(tempDetail[field])
            : tempDetail[field] === null || tempDetail[field] === undefined
            ? ''
            : tempDetail[field]
        }
        type={type}
        placeholder={placeholder}
        required={required}
        onChange={(e) => {
          if (props.onChange) {
            props.onChange(e.target.value)
          } else if (setTempDetail) {
            setTempDetail((prev) => ({ ...prev, [field]: e.target.value }))
          } else {
            if (process.env.NODE_ENV !== 'production') {
              console.warn('DetailInput requires either onChange or setTempDetail')
            }
          }
        }}
        startAdornment={startAdornment}
        sx={{
          input: {
            pl: startAdornment ? 1 : undefined,
          },
        }}
        onKeyDown={keyDownSubmit}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}
export default DetailInput
